/*============================================================================
  Barbell — fit-preference tracking: save path.

  Records the shopper's size picks (numeric waist, inseam, or alpha size) into
  localStorage so the next product page can auto-apply them.

  Loaded deferred, after theme.js. The pre-paint variant auto-select lives
  inline in snippets/barbell-fit-apply.liquid; the shared runtime and per-
  product config live in snippets/barbell-fit-config.liquid (window.BarbellFit).
  This file only handles SAVING a preference when the shopper changes a size.
============================================================================*/
(function () {
  'use strict';

  function initFitSavePath() {
    try {
      var BF = window.BarbellFit;
      /* window.BarbellFit only exists on in-scope product pages */
      if (!BF || !BF.product || BF._saveBound) return;

      var profileName = BF.resolveProfile();
      var profile = BF.config.profiles[profileName];
      if (!profile || profile.type === 'none') return;

      var roles = profile.roles;            /* e.g. { primarySize: 'pantsWaist', length: 'pantsLength' } */
      var options = BF.product.options || {};
      var isAlpha = profile.type === 'alpha';

      var section = document.querySelector(
        '.product-section[data-product-id="' + BF.product.productId + '"]'
      ) || document.querySelector('.product-section[data-product-id]');
      if (!section) return;

      BF._saveBound = true;

      /* Delegated listener — fires only on genuine user changes. The pre-paint
         auto-select sets inputs directly without dispatching events, so it
         never triggers this handler (no feedback loop). */
      section.addEventListener('change', function (evt) {
        try {
          var el = evt.target;
          if (!el || !el.matches || !el.matches('[data-variant-input]')) return;

          var role = (options[el.getAttribute('data-index')] || {}).role;
          if (role !== 'primarySize' && role !== 'length') return;

          var bucket = roles[role];
          if (!bucket) return;

          var raw;
          if (el.tagName === 'SELECT') raw = el.value;
          else if (el.checked) raw = el.value;
          else return;
          if (raw == null || raw === '') return;

          /* alpha sizes are normalised to a canonical token; numeric values
             (waist / inseam) are stored as-is */
          var value = (role === 'primarySize' && isAlpha)
            ? BF.canonAlpha(raw)
            : String(raw).trim();
          if (!value) return;

          BF.writePref(bucket, value);

          try {
            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({
              event: 'fit_preference_saved',
              fit_bucket: bucket,
              fit_value: value
            });
          } catch (e) {}
        } catch (e) {}
      });
    } catch (e) {
      /* fail safe — saving is best-effort */
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initFitSavePath);
  } else {
    initFitSavePath();
  }
})();
